var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "quick" }, [
    _c(
      "div",
      { staticClass: "quick-title" },
      [
        _c(
          "Title",
          {
            attrs: { title: _vm.$t("pc_biz_group_quick") /* 快速分组 */ },
            on: { close: _vm.onCancel },
          },
          [
            _c(
              "yxt-tooltip",
              {
                staticClass: "item",
                attrs: {
                  effect: "dark",
                  content: _vm.$t(
                    "pc_biz_group_quick_rule" /*将未分组成员按一定规则自动分组*/
                  ),
                  placement: "right",
                },
              },
              [
                _c("img", {
                  staticClass: "quick-title__icon",
                  attrs: { src: require("../assets/question_cirlce.png") },
                }),
              ]
            ),
          ],
          1
        ),
      ],
      1
    ),
    _c("div", { staticClass: "quick-content" }, [
      _c("div", { staticClass: "quick-content-box" }, [
        _c("span", { staticClass: "quick-content-box__tip" }, [
          _vm._v(
            _vm._s(_vm.$t("pc_biz_group_quick_info", [_vm.leftMemberNum]))
          ),
        ]),
        _c(
          "div",
          [
            _vm._v(
              "\n          " +
                _vm._s(_vm.$t("pc_biz_group_quick_input_1") /* 分为 */) +
                "\n          "
            ),
            _c("yxt-input-number", {
              ref: "groupInput",
              attrs: { min: 1, max: _vm.leftMemberNum, type: "number" },
              on: { change: _vm.onGroupChange, blur: _vm.computeMemberNum },
              model: {
                value: _vm.groupNum,
                callback: function ($$v) {
                  _vm.groupNum = $$v
                },
                expression: "groupNum",
              },
            }),
            _vm._v(
              _vm._s(_vm.$t("pc_biz_group_quick_input_2") /* 组，每组约 */) +
                "\n          "
            ),
            _c("yxt-input-number", {
              ref: "memberInput",
              attrs: { type: "number", min: 1 },
              on: { change: _vm.onNumberChange, blur: _vm.computeGroupNum },
              model: {
                value: _vm.memberNum,
                callback: function ($$v) {
                  _vm.memberNum = $$v
                },
                expression: "memberNum",
              },
            }),
            _vm._v(
              _vm._s(_vm.$t("pc_biz_group_quick_input_3") /* 人 */) +
                "\n        "
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "quick-content-box-rule" },
          [
            _c(
              "yxt-checkbox",
              {
                attrs: { value: _vm.rule === "split" },
                nativeOn: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.setRule("split")
                  },
                },
              },
              [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "pc_biz_group_quick_split_dept"
                    ) /* 同部门员工分开（尽可能） */
                  )
                ),
              ]
            ),
            _c(
              "yxt-checkbox",
              {
                attrs: { value: _vm.rule === "same" },
                nativeOn: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.setRule("same")
                  },
                },
              },
              [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "pc_biz_group_quick_same_dept"
                    ) /* 同部门员工同组（尽可能） */
                  )
                ),
              ]
            ),
          ],
          1
        ),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "quick-footer" },
      [_c("Submit", { on: { cancel: _vm.onCancel, submit: _vm.onSubmit } })],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }